
import { useState, useEffect } from 'react';

export const useEmailDatabaseError = () => {
  const [databaseError, setDatabaseError] = useState(false);

  useEffect(() => {
    const dbErrorInStorage = localStorage.getItem('email_db_error') === 'true';
    if (dbErrorInStorage) {
      setDatabaseError(true);
    }
    
    const handleError = (event: ErrorEvent) => {
      const errorMsg = event.error?.message || event.message;
      if (errorMsg && (
        errorMsg.includes('SQLite') || 
        errorMsg.includes('database') ||
        errorMsg.includes('WebAssembly')
      )) {
        setDatabaseError(true);
        localStorage.setItem('email_db_error', 'true');
      }
    };
    
    window.addEventListener('error', handleError);
    return () => window.removeEventListener('error', handleError);
  }, []);

  const clearError = () => {
    setDatabaseError(false);
    localStorage.removeItem('email_db_error');
  };

  return { databaseError, clearError };
};
